import { Card } from 'shared/components/ui/Card';
import { Badge } from 'shared/components/ui/Badge';
import { Button } from 'shared/components/ui/Button';
import { useToast } from 'shared/components/ui/Toast';
import { useArenaProfile } from 'shared/contexts/ArenaProfileContext';

export function CourtsList() {
  const toast = useToast();
  const { profile } = useArenaProfile();

  return (
    <Card>
      <div className="flex items-center justify-between">
        <h3 className="font-heading font-semibold text-ink">Quadras</h3>
        <Button
          variant="ghost"
          className="px-3 py-1 text-xs"
          onClick={() =>
            toast({
              tone: 'info',
              title: 'Cadastrar quadra',
              description: 'Em breve: nome, esportes permitidos, cobertura e preço por faixa de horário.',
            })
          }
        >
          + Nova quadra
        </Button>
      </div>

      <div className="mt-3 flex flex-col gap-2">
        {profile.courts.map((court) => (
          <div
            key={court.id}
            className="flex items-center justify-between gap-3 rounded-xl border border-border/70 px-4 py-3"
          >
            <div className="min-w-0">
              <p className="truncate text-sm font-medium text-ink">{court.name}</p>
              <div className="mt-1 flex flex-wrap gap-1">
                {court.sportIds.length === 0 && <span className="text-xs text-ink-secondary">sem esporte definido</span>}
                {court.sportIds.map((sport) => (
                  <Badge key={sport} tone="accent">
                    {sport}
                  </Badge>
                ))}
              </div>
            </div>
            <span className="flex-shrink-0 text-sm font-semibold text-ink">R$ {court.pricePerHour}/h</span>
          </div>
        ))}
      </div>
    </Card>
  );
}
